import React from "react";
import { Box, Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import { useField } from "formik";

type OcCheckboxFormikProps = CheckboxProps & {
  name: string;
  label: string;
  disabled?: boolean;
};
export const OcCheckboxFormik: React.FC<OcCheckboxFormikProps> = ({
  key,
  disabled,
  label,
  ...props
}) => {
  const [field, ,] = useField(props.name);
  return (
    <Box key={key}>
      <FormControlLabel
        control={
          <Checkbox
            checked={field.value ?? false}
            onChange={field.onChange}
            {...props}
            disabled={disabled}
          />
        }
        label={label}
      />
    </Box>
  );
};
